module.exports = __webpack_public_path__ + "img/full1-min.10926353.png";